module.exports = __webpack_public_path__ + "img/dinersclub.32d88217.png";